export const ROUTING = "ROUTING_MENU_ENABLE";
export const SPEED_CAMERAS = "SPEED_CAMERAS_MENU_ENABLE";
export const TRAFFIC = "TRAFFIC_MENU_ENABLE";
export const SHARE_MAP = "SHARE_MAP_MENU_ENABLE";
export const ABOUT_APP = "ABOUT_APP_MENU_ENABLE";
export const REPORT_MISTAKES = "REPORT_MISTAKES_MENU_ENABLE";

export const checkForMenuTypes = menyType => ([ROUTING, SPEED_CAMERAS, TRAFFIC, SHARE_MAP, ABOUT_APP, REPORT_MISTAKES].every(section => menyType !== section));


// WEBPACK FOOTER //
// ./C:/Users/viesis/Desktop/deportacijas/src/mapbuttons/menuTypes.js